import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, Subject, throwError } from "rxjs";

import {
  DeviceMake,
  DeviceModel,
  PolicyResponse,
  SalesActivity,
  Region,
  GSPSnackBarData,
  GspSnackbar,
  PolicyDetails
} from '../models';
import { RequestCriticalLevel, ADPResourceService as ResourceService } from 'digital-core';
import { HeaderFactoryService } from './header-factory.service';
import { ConfigService } from './config.service';
import { NotificationService } from "digital-core";
import { SnackBarBodyComponent } from "../components";
import { Product, AthenaRequest, AthenaDeviceProduct, AthenaInfo, GadgetResponse, SelectedProduct } from "../models/product/product";
import { ErrorLogService, SerializationHelperService } from "common";
import { GetProtectionPlansModel } from "common/models/device/get-protection-plans-model";
import { catchError } from "rxjs/operators";

@Injectable()
export class DeviceService {
  webApiUrl: string;
  public afterPlanSelection = new Subject<FilteredProduct>();

  constructor(
    private httpsClient: HttpClient,
    public resourceService: ResourceService,
    private headerService: HeaderFactoryService,
    private notificationService: NotificationService,
    public serializationHelperService: SerializationHelperService,
    private configService: ConfigService,
    private errorLogService: ErrorLogService
  ) {
    this.webApiUrl = configService.apiUrl;
  }

  checkDevice(allowEnrollviaPC: boolean): boolean {
    if (allowEnrollviaPC) {

      if ((/Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent))) {
        return true;
      }
      else {
        setTimeout(() => {
          this.notificationService.showNotification(
            SnackBarBodyComponent,
            new GSPSnackBarData(
              this.resourceService.getViewLabel(
                "Dashboard_Text_ReturnGlobalFailDescription"
              ),
              this.resourceService.getViewLabel(
                "Dashboard_Text_ReturnGlobalFailTitle"
              ),
              "error"
            ),
            new GspSnackbar("error")
          );
        });
        return false;
      }

    }
    else {
      return true;
    }

  }

  searchPlan(getProtectPlans: GetProtectionPlansModel): Observable<Product[]> {
    // tslint:disable-next-line:max-line-length
    let parameters;
    if (getProtectPlans.Make && getProtectPlans.Model) {
      parameters = `IMEI=${getProtectPlans.IMEI}&make=${encodeURIComponent(getProtectPlans.Make)}&model=${encodeURIComponent(getProtectPlans.Model)}&devicePrice=${getProtectPlans.PurchasePrice}`
    } else {
      if (getProtectPlans.ProgramType) {
        parameters = `IMEI=${getProtectPlans.IMEI}&programType=${getProtectPlans.ProgramType}&devicePrice=${getProtectPlans.PurchasePrice}`
      }
      else {
        parameters = `IMEI=${getProtectPlans.IMEI}&devicePrice=${getProtectPlans.PurchasePrice}`
      }
    }
    const formData = new FormData();
    formData.append('protectionPlans', JSON.stringify(getProtectPlans));
    return this.httpsClient.post<Product[]>(`${this.webApiUrl}api/v${this.configService.apiVersion}/device/protectionplans`,
      formData,
      this.headerService.getAuthorizationHeaderOptions()
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_Error"
        ))
      }
      return throwError(error);
    }));
  }



  getDealerGadgetsDetails(): Observable<GadgetResponse> {
    return this.httpsClient.get<GadgetResponse>(
      `${this.webApiUrl}api/v${this.configService.apiVersion
      }/device/getDealerGadgetsDetails`,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  //Call Athena service = Testing
  searchPlans(make: string, model: string, devicePrice: number): Observable<Product[]> {
    let parameters;
    if (make && model) {
      parameters = `make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}&devicePrice=${devicePrice}`
    } else {
      parameters = `devicePrice=${devicePrice}`
    }

    //Mock call to Athena service - uncmment to test code
    //let athenaInfoResponse = this.searchAthenaInfo(this.mockAthenaServiceData());
    //console.log("Do something with Athena response: " + athenaInfoResponse);

    return this.httpsClient.get<Product[]>(
      `${this.webApiUrl}api/v${this.configService.apiVersion
      }/d2cSaleApplication/protectionplans?${parameters}`,
      this.headerService.getAuthorizationHeaderOptions()
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_Error"
        ))
      }
      return throwError(error);
    }));
  }

  //Athena Service
  searchAthenaInfo(athenaDeviceProducts: AthenaDeviceProduct[]): Observable<AthenaInfo> {

    //Generate Atehna request
    let athenaProducts: AthenaRequest = {
      athenaDeviceProducts: athenaDeviceProducts
    };

    //Make a call to Athena service
    return this.httpsClient
      .post<AthenaInfo>(
        `${this.configService.apiUrl}api/v${this.configService.apiVersion}/Athena/getAthenaInformation`,
        athenaProducts,
        this.headerService.getAuthorizationHeaderOptions()
      );
  }

  getDeviceMakes(): Observable<DeviceMake[]> {
    let url = `${this.webApiUrl}api/v${this.configService.apiVersion
      }/device/makes`;
    return this.httpsClient.get<DeviceMake[]>(
      url,
      this.headerService.getAuthorizationHeaderOptions()
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_Error"
        ))
      }
      return throwError(error);
    }));
  }

  getDeviceModels(makeid: string): Observable<DeviceModel[]> {
    return this.httpsClient.get<DeviceModel[]>(
      `${this.webApiUrl}api/v${this.configService.apiVersion
      }/device/models?makeid=${makeid}`,
      this.headerService.getAuthorizationHeaderOptions()
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_Error"
        ))
      }
      return throwError(error);
    }));
  }

  getDeviceModelsforMS1(makeid: string): Observable<DeviceModel[]> {
    return this.httpsClient.get<DeviceModel[]>(
      `${this.webApiUrl}api/v${this.configService.apiVersion
      }/device/deviceModels?makeid=${makeid}`,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  checkIMEI(numValue: string) {
    if (!numValue) {
      return false;
    }
    if (numValue.trim().length !== 15) {
      return false;
    }
    // accept only digits, dashes or spaces
    if (!/[0-9-\s]+$/.test(numValue)) {
      return false;
    }

    let value = numValue.toString();
    // value = value.replace(/\D/g, "");
    // The Luhn Algorithm
    let nCheck = 0;
    let bEven = false;

    for (let n = value.length - 1; n >= 0; n--) {
      let cDigit = value.charAt(n),
        nDigit = parseInt(cDigit, 10);

      if (bEven && (nDigit *= 2) > 9) {
        nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }
    return nCheck > 0 ? nCheck % 10 === 0 : false;
  }

  submitPolicy(salesActivity: SalesActivity): Observable<PolicyResponse> {

    const formData = new FormData();
    formData.append('salesActivity', JSON.stringify(salesActivity));

    return this.httpsClient.post<PolicyResponse>(
      `${this.webApiUrl}api/v${this.configService.apiVersion}/device/policy`,
      formData,
      this.headerService.getAuthorizationHeaderOptions(null,
        RequestCriticalLevel.Critical
      )
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_SignatureError"
        ))
      }
      return throwError(error);
    }));
  }

  cancelPolicy(policyDetails: PolicyDetails): Observable<PolicyResponse> {

    const formData = new FormData();
    formData.append('policyDetails', JSON.stringify(policyDetails));

    return this.httpsClient.post<PolicyResponse>(
      `${this.webApiUrl}api/v${this.configService.apiVersion}/device/cancelPolicy`,
      formData,
      this.headerService.getAuthorizationHeaderOptions(null,
        RequestCriticalLevel.Critical
      )
    );
  }

  cancelPolicyElita(policyDetails: PolicyDetails): Observable<PolicyResponse> {

    const formData = new FormData();
    formData.append('policyDetails', JSON.stringify(policyDetails));

    return this.httpsClient.post<PolicyResponse>(
      `${this.webApiUrl}api/v${this.configService.apiVersion}/device/cancelPolicyElita`,
      formData,
      this.headerService.getAuthorizationHeaderOptions(null,
        RequestCriticalLevel.Critical
      )
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_Error"
        ))
      }
      return throwError(error);
    }));
  }

  submitPolicyDocuments(salesActivity: SalesActivity): Observable<PolicyResponse> {

    const formData = new FormData();
    formData.append('salesActivity', JSON.stringify(salesActivity));

    return this.httpsClient.post<PolicyResponse>(
      `${this.webApiUrl}api/v${this.configService.apiVersion}/device/policyDocuments`,
      formData,
      this.headerService.getAuthorizationHeaderOptions()
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_SignatureError"
        ))
      }
      return throwError(error);
    }));
  }

  sendEmailDocuments(salesActivity: SalesActivity): Observable<PolicyResponse> {

    const formData = new FormData();
    formData.append('salesActivity', JSON.stringify(salesActivity));

    return this.httpsClient.post<PolicyResponse>(
      `${this.webApiUrl}api/v${this.configService.apiVersion}/device/sendEmailDocuments`,
      formData,
      this.headerService.getAuthorizationHeaderOptions()
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_SignatureError"
        ))
      }
      return throwError(error);
    }));
  }

  submitPolicyNoDocuments(salesActivity: SalesActivity): Observable<PolicyResponse> {

    const formData = new FormData();
    formData.append('salesActivity', JSON.stringify(salesActivity));

    return this.httpsClient.post<PolicyResponse>(
      `${this.webApiUrl}api/v${this.configService.apiVersion}/device/policyNoDocuments`,
      formData,
      this.headerService.getAuthorizationHeaderOptions(null,
        RequestCriticalLevel.Low
      )
    ).pipe(catchError((error: HttpErrorResponse) => {
      if (error.error) {
        this.errorLogService.showSnackBarMessage(error, this.resourceService.getViewLabel(
          "Global_Text_SignatureError"
        ))
      }
      return throwError(error);
    }));
  }

  getRegions(): Observable<Region[]> {
    let url = `${this.webApiUrl}api/v${this.configService.apiVersion}/device/regions`;
    return this.httpsClient.get<Region[]>(url, this.headerService.getAuthorizationHeaderOptions());
  }

  //Mock Athena reuqest - Testing
  mockAthenaServiceData() {
    //Create a mock request
    let athenaDeviceProducts = [
      {
        "imeiNumber": "",
        "item": "iPad",
        "itemNumber": "1",
        "loss": "false",
        "make": "Apple",
        "model": "iPad Air 32GB Wi-Fi",
        "value": "800"
      },
      {
        "imeiNumber": "",
        "item": "Tablet",
        "itemNumber": "2",
        "loss": "true",
        "make": "Samsung",
        "model": "Galaxy Tab A 9.7 Wi-Fi 16GB",
        "value": "800"
      },
      {
        "imeiNumber": "",
        "item": "Tablet",
        "itemNumber": "3",
        "loss": "true",
        "make": "Samsung",
        "model": "Galaxy Tab A 9.7 Wi-Fi 16GB",
        "value": "400"
      },
    ];

    return athenaDeviceProducts;
  }

  getDeviceBandValue(device: any): Observable<string> {

    const formData = new FormData();
    formData.append('device', JSON.stringify(device));

    let url = `${this.webApiUrl}api/v${this.configService.apiVersion}/device/getBandValue`;
    return this.httpsClient.post<string>(url,
      formData,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }

  getProductForAgent(coverageType: string): string {
    const productsList = this.resourceService.getComplexList("Global_Agent_Products");
    let coverage = "";
    productsList.forEach((productFromSF) => {
      if ((coverageType.toLocaleLowerCase().includes(productFromSF.Value.toLocaleLowerCase()))) {
        coverage = productFromSF.Value;
      }
    });
    return coverage;
  }
}

export interface ProtectionPlan {
  title: string;
  description: string;
  monthly_cost: number;
  yearyl_cost: number;
  Model: string;
}

export interface FilteredProduct {
  selectedProduct?: SelectedProduct
}
